/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 実行状況 (1:未完了, 2:完了, 3:キャンセル, 4:予約(将来対応), 5:探車失敗)
 * @export
 * @enum {number}
 */
export enum OrderStatusEnum {
    /** 未完了 */
    INCOMPLETE = '1',
    /** 完了 */
    COMPLETED = '2',
    /** キャンセル */
    CANCELLED = '3',
    /** 予約(将来対応) */
    RESERVED = '4',
    /** 探車失敗 */
    SEARCH_FAILED = '5'
}

/**
 * 実行状況 (1:未完了, 2:完了, 3:キャンセル, 4:予約(将来対応), 5:探車失敗) の Union 型
 * @export
 * @typedef OrderStatus
 */
export type OrderStatus =
  typeof OrderStatusEnum[keyof typeof OrderStatusEnum];

/**
 * 実行状況 (1:未完了, 2:完了, 3:キャンセル, 4:予約(将来対応), 5:探車失敗) のラベルマップ
 * @export
 */
export const OrderStatusLabels = {
    /**
     * 数値キー: OrderStatusEnum.INCOMPLETE
     * 名前キー:  INCOMPLETE
     */
    [OrderStatusEnum.INCOMPLETE]: '未完了',
    INCOMPLETE:                             '未完了',
    /**
     * 数値キー: OrderStatusEnum.COMPLETED
     * 名前キー:  COMPLETED
     */
    [OrderStatusEnum.COMPLETED]: '完了',
    COMPLETED:                             '完了',
    /**
     * 数値キー: OrderStatusEnum.CANCELLED
     * 名前キー:  CANCELLED
     */
    [OrderStatusEnum.CANCELLED]: 'キャンセル',
    CANCELLED:                             'キャンセル',
    /**
     * 数値キー: OrderStatusEnum.RESERVED
     * 名前キー:  RESERVED
     */
    [OrderStatusEnum.RESERVED]: '予約(将来対応)',
    RESERVED:                             '予約(将来対応)',
    /**
     * 数値キー: OrderStatusEnum.SEARCH_FAILED
     * 名前キー:  SEARCH_FAILED
     */
    [OrderStatusEnum.SEARCH_FAILED]: '探車失敗',
    SEARCH_FAILED:                             '探車失敗',
} as const;

/**
 * 実行状況 (1:未完了, 2:完了, 3:キャンセル, 4:予約(将来対応), 5:探車失敗) のラベル Union 型
 * @export
 * @typedef OrderStatusLabel
 */
export type OrderStatusLabel =
  typeof OrderStatusLabels[keyof typeof OrderStatusLabels];

/**
 * 実行状況 (1:未完了, 2:完了, 3:キャンセル, 4:予約(将来対応), 5:探車失敗) のラベル取得関数
 * @export
 * @param { OrderStatus } value - 列挙体の値
 * @returns { OrderStatusLabel } ラベル文字列
 */
export function getOrderStatusLabel(
  value: OrderStatus
): OrderStatusLabel {
  return OrderStatusLabels[value];
}

/**
 * 実行状況 (1:未完了, 2:完了, 3:キャンセル, 4:予約(将来対応), 5:探車失敗) のラベル配列を取得する関数
 * @export
 * @param { OrderStatus[] } values - 列挙体の値配列
 * @returns { OrderStatusLabel[] } ラベル文字列配列
 */
export function getOrderStatusLabels(values: OrderStatus[]): OrderStatusLabel[] {
  return values.map((value) => getOrderStatusLabel(value));
}

/**
 * 実行状況 (1:未完了, 2:完了, 3:キャンセル, 4:予約(将来対応), 5:探車失敗) のラベル配列
 * @export
 */
export const OrderStatusLabelList = [
  '未完了','完了','キャンセル','予約(将来対応)','探車失敗',
] as const;

